module.exports = __webpack_public_path__ + "img/potencia_b.6a516f2e.svg";